import React from 'react';
import { useAppearance } from '../contexts/AppearanceContext';

const CitationRenderer = ({ content, onCitationClick, contextSpaceId }) => {
  const { isSuppleMode } = useAppearance();

  // Parse citations and create numbered inline citations with references section
  const parseInlineCitations = (text) => {
    // Look for patterns like [Source: ResourceTitle] or [Source: ConversationTitle]
    const citationRegex = /\[Source:\s*([^\]]+)\]/g;
    const parts = [];
    const references = [];
    let lastIndex = 0;
    let citationNumber = 1;
    let match;

    while ((match = citationRegex.exec(text)) !== null) {
      // Add text before the citation
      if (match.index > lastIndex) {
        parts.push({
          type: 'text',
          content: text.slice(lastIndex, match.index)
        });
      }

      const citationTitle = match[1].trim();
      
      // Check if this citation already exists in references
      let existingRefIndex = references.findIndex(ref => ref.title === citationTitle);
      let refNumber;
      
      if (existingRefIndex !== -1) {
        refNumber = existingRefIndex + 1;
      } else {
        refNumber = citationNumber;
        references.push({
          number: refNumber,
          title: citationTitle
        });
        citationNumber++;
      }

      // Add the inline citation number
      parts.push({
        type: 'inline_citation',
        number: refNumber,
        title: citationTitle
      });

      lastIndex = match.index + match[0].length;
    }

    // Add remaining text
    if (lastIndex < text.length) {
      parts.push({
        type: 'text',
        content: text.slice(lastIndex)
      });
    }

    return { parts, references };
  };

  const handleCitationClick = (citationTitle) => {
    if (onCitationClick) {
      onCitationClick(citationTitle, contextSpaceId);
    }
  };

  
  const { parts, references } = parseInlineCitations(content);

  return (
    <span>
      {parts.map((part, index) => {
        if (part.type === 'text') {
          return <span key={index}>{part.content}</span>;
        } else if (part.type === 'inline_citation') {
          return (
            <button
              key={index}
              onClick={() => handleCitationClick(part.title)}
              className={`inline-flex items-center justify-center w-5 h-5 mx-1 rounded-full text-xs font-medium transition-colors cursor-pointer ${
                isSuppleMode
                  ? 'bg-purple-500/20 text-purple-300 hover:bg-purple-500/30 hover:text-purple-200 border border-purple-300/30'
                  : 'bg-blue-100 text-blue-700 hover:bg-blue-200 hover:text-blue-800 border border-blue-200'
              }`}
              title={`Click to preview: ${part.title}`}
              style={{ verticalAlign: 'super', fontSize: '10px', lineHeight: '1' }}
            >
              {part.number}
            </button>
          );
        }
        return null;
      })}
    </span>
  );
};

export default CitationRenderer;